/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import { IFormElementInlineConfig } from "../../../shared/FormModel/elements/IFormElementInlineConfig";
import { BEM } from "../../../shared/BEM";

/**
 * Pushes inline element modifiers to existing modifier array based on element config
 *
 * @param config Element config
 * @param mods Modifiers array
 */
export function applyInlineElementMods(config: IFormElementInlineConfig, mods: Array<string>) {

	switch(config.width) {
		case "1":
			mods.push("width-1"); break;
		case "1/2":
			mods.push("width-1-2"); break;
		case "1/3":
			mods.push("width-1-3"); break;
		case "1/4":
			mods.push("width-1-4"); break;
		case "1/6":
			mods.push("width-1-6"); break;
		case "2/3":
			mods.push("width-2-3"); break;
		case "3/4":
			mods.push("width-3-4"); break;
		case "2/6":
			mods.push("width-2-6"); break;
		case "1/5":
			mods.push("width-1-5"); break;
		case "2/5":
			mods.push("width-2-5"); break;
		case "3/5":
			mods.push("width-3-5"); break;
		case "4/5":
			mods.push("width-4-5"); break;
		case "1/8":
			mods.push("width-1-8"); break;
		case "3/8":
			mods.push("width-3-8"); break;
		case "1/10":
			mods.push("width-1-10"); break;
		case "row-actions":
			mods.push("width-row-actions"); break;
		default:
			mods.push("width-auto"); break;
	}

}